import React, { useEffect, useState } from "react";
import popupCloseIcon from "../../assests/page/popup-close-icon.svg";
import backIcon from "../../assests/page/chevron-left.svg";
import unitedStatesFlag from "../../assests/page/Flag-United-States-of-America 1.svg";
import GeneralPopupBackground from ".";
import PaymentProcess from "./paymentProcess";
import dropdownIcon from "../../assests/page/contact-dropdown.svg";
import arrowUp from "../../assests/page/contact-arrow-up.svg";
import checkbox from "../../assests/page/checkbox-icon.svg";
import checkboxClicked from "../../assests/page/checkbox-icon-clicked.svg";
import {
  errorToast,
  moneyHubContinents,
  restfulCountriesApi,
  stripeSupportedCountriesCode,
} from "../../utils/constants";
import searchIcon from "../../assests/sideBar/search-icon.svg";
import LoadingPopup from "./loading";
import StripePopup from "./stripe";
import { LinkBankOption } from "./linkbankOptions";
import Avatar from "react-avatar";
import selectBankClicked from "../../assests/page/list-square-clicked.svg";
import SuccessPopup from "./success";
import AddFunds from "./addFunds";
import SelectBank from "./selectBank";
import {
  blinkActiveBanks,
  blinkRevokeLastPermission,
} from "../../utils/helpers/blink";
import {
  iniciadorActiveBanks,
  iniciadorRevokeLink,
} from "../../utils/helpers/iniciador";
import { useTranslation } from "react-i18next";

const LinkBank = (props) => {
  const { t } = useTranslation();
  const [step, setStep] = useState(props.currentStep ? props.currentStep : "1");
  const [selectedCountry, setSelectedCountry] = useState({
    area: "1",
    flag: unitedStatesFlag,
    name: "United States",
    continent: "north america",
    code: "US",
  });
  const [searchActive, setSearchActive] = useState(false);
  const [userNumber, setUserNumber] = useState("");
  const [userInput, setUserInput] = useState("");
  const [newSearchContent, setNewSearchContent] = useState(null);
  const [bankList, setBankList] = useState([]);
  const [bankListBr, setBankListBr] = useState([]);
  const [countryList, setCountryList] = useState(props.countryList || []);
  const [isCheckboxClicked, setIsCheckboxClicked] = useState(null);

  const { allCountries } = props.generalDataProps;

  useEffect(() => {
    const handleCountryList = () => {
      if (countryList?.length === 0 && props.buttonAction === "link-card") {
        const countries = allCountries
          ? Object.values(allCountries)?.filter((cnt) =>
              stripeSupportedCountriesCode.includes(
                cnt?.countryCode?.toUpperCase(),
              ),
            )
          : [];

        setCountryList(countries);
      }

      if (countryList?.length === 0 && props.buttonAction === "link-bank") {
        const countries = allCountries
          ? Object.values(allCountries)?.filter(
              (cnt) =>
                moneyHubContinents.includes(cnt?.continent?.toLowerCase()) ||
                cnt?.code === "BR",
            )
          : [];

        setCountryList(countries);
      }
    };

    handleCountryList();
  }, [countryList, allCountries, props.buttonAction]);

  useEffect(() => {
    (async () => {
      const handleBankList = async () => {
        setBankListBr(await iniciadorActiveBanks());
        setBankList(await blinkActiveBanks());
      };

      await handleBankList();
    })();
  }, []);

  const handleNextButtonDisplay = () => {};

  const handleStep2 = () => {
    setIsCheckboxClicked(null);
    if (selectedCountry?.code === "CH" && props.buttonAction === "link-bank") {
      props.setPopupContent(
        <SelectBank
          setShowPopup={props.setShowPopup}
          setPopupContent={props.setPopupContent}
          setPopupContentPosition={props.setPopupContentPosition}
          setFavouriteClicked={props.setFavouriteClicked}
          bankList={bankList}
          generalDataProps={props.generalDataProps}
          backClickPopup={
            <LinkBankOption
              setShowPopup={props.setShowPopup}
              setPopupContent={props.setPopupContent}
              setPopupContentPosition={props.setPopupContentPosition}
              generalDataProps={props.generalDataProps}
            />
          }
          countryList={countryList}
          action="link-bank"
        />,
      );
      props.setPopupContentPosition("flex-end");
      props.setShowPopup(true);
    } else if (
      selectedCountry?.code === "BR" &&
      props.buttonAction === "link-bank"
    ) {
      props.setPopupContent(
        <SelectBank
          setShowPopup={props.setShowPopup}
          setPopupContent={props.setPopupContent}
          setPopupContentPosition={props.setPopupContentPosition}
          setFavouriteClicked={props.setFavouriteClicked}
          bankList={bankListBr}
          generalDataProps={props.generalDataProps}
          backClickPopup={
            <LinkBankOption
              setShowPopup={props.setShowPopup}
              setPopupContent={props.setPopupContent}
              setPopupContentPosition={props.setPopupContentPosition}
              generalDataProps={props.generalDataProps}
            />
          }
          countryList={countryList}
          action="link-bank"
        />,
      );
      props.setPopupContentPosition("flex-end");
      props.setShowPopup(true);
    } else if (
      selectedCountry?.code !== "CH" &&
      selectedCountry?.code !== "BR" &&
      moneyHubContinents.includes(selectedCountry?.continent?.toLowerCase()) &&
      props.buttonAction === "link-bank"
    ) {
      props.setPopupContent(
        <LoadingPopup
          setShowPopup={props.setShowPopup}
          setPopupContent={props.setPopupContent}
          setPopupContentPosition={props.setPopupContentPosition}
          setFavouriteClicked={props.setFavouriteClicked}
          action="moneyhub-connect"
          isCustom={true}
          customTextHeader="Searching..."
          customTextFooter={`Looking for bank account linked with your wallet.`}
          generalDataProps={props.generalDataProps}
          countryList={countryList}
        />,
      );
      props.setPopupContentPosition("flex-end");
      props.setShowPopup(true);
    } else if (
      props.buttonAction === "link-card" &&
      stripeSupportedCountriesCode.includes(
        selectedCountry?.code?.toUpperCase(),
      )
    ) {
      props.setPopupContent(
        <LoadingPopup
          setShowPopup={props.setShowPopup}
          setPopupContent={props.setPopupContent}
          setPopupContentPosition={props.setPopupContentPosition}
          setFavouriteClicked={props.setFavouriteClicked}
          action="stripe-connect"
          isCustom={true}
          customTextHeader="Searching..."
          customTextFooter={`Looking for card linked with your wallet in ${selectedCountry.code}`}
          countryCode={selectedCountry.code}
          generalDataProps={props.generalDataProps}
          countryList={countryList}
        />,
      );
      props.setPopupContentPosition("flex-end");
      props.setShowPopup(true);
    } else {
      props.setPopupContent(
        <StripePopup
          setShowPopup={props.setShowPopup}
          setPopupContent={props.setPopupContent}
          setPopupContentPosition={props.setPopupContentPosition}
          countryCode={selectedCountry.code}
          generalDataProps={props.generalDataProps}
          countryList={countryList}
        />,
      );
      props.setPopupContentPosition("center");
      props.setShowPopup(true);
    }
  };

  return (
    <>
      <div className="search-filter-popup">
        <div className="search-filter-popup-content">
          <div className="borrow-popup-content">
            <div className="borrow-popup-content-header">
              <div className="add-funds-content-header">
                <div className="add-funds-content-header-text-container">
                  {Number(step) > 1 && (
                    <img
                      onClick={() => {
                        if (Number(step) === 2) {
                          setSearchActive(true);
                        }
                        setStep(`${Number(step) - 1}`);
                        setIsCheckboxClicked(null);
                      }}
                      className="borrow-popup-back-icon"
                      alt="Back Icon"
                      src={backIcon}
                    />
                  )}
                  {Number(step) === 1 && (
                    <img
                      onClick={() => {
                        setIsCheckboxClicked(null);
                        props.setPopupContent(
                          <LinkBankOption
                            setShowPopup={props.setShowPopup}
                            setPopupContent={props.setPopupContent}
                            setPopupContentPosition={
                              props.setPopupContentPosition
                            }
                            generalDataProps={props.generalDataProps}
                          />,
                        );
                        props.setPopupContentPosition("flex-end");
                        props.setShowPopup(true);
                      }}
                      className="borrow-popup-back-icon"
                      alt="Back Icon"
                      src={backIcon}
                    />
                  )}
                  <p className="add-funds-search-header-text">
                    {props.buttonAction === "link-card"
                      ? `${t("linkBank.linkCard")}`
                      : `${t("linkBank.linkBankAccount")}`}
                  </p>
                </div>
                <img
                  onClick={() => {
                    setIsCheckboxClicked(null);
                    props.setShowPopup(false);
                    props.setPopupContent(null);
                    props.setPopupContentPosition("center");
                    if (props.setFavouriteClicked) {
                      props.setFavouriteClicked(false);
                    }
                    setNewSearchContent(null);
                  }}
                  className="add-funds-popup-close-icon"
                  alt="Close Icon"
                  src={popupCloseIcon}
                />
              </div>
              {step === "1" && (
                <div className="borrow-popup-content-header-second">
                  <div className="borrow-popup-content-slider-active"></div>
                  <div className="borrow-popup-content-slider"></div>
                  <div className="borrow-popup-content-slider"></div>
                </div>
              )}
              {step === "2" && (
                <div className="borrow-popup-content-header-second">
                  <div className="borrow-popup-content-slider-active"></div>
                  <div className="borrow-popup-content-slider-active"></div>
                  <div className="borrow-popup-content-slider"></div>
                </div>
              )}
              {step === "3" && (
                <div className="borrow-popup-content-header-second">
                  <div className="borrow-popup-content-slider-active"></div>
                  <div className="borrow-popup-content-slider-active"></div>
                  <div className="borrow-popup-content-slider-active"></div>
                </div>
              )}
            </div>
            <div className="borrow-popup-content-body">
              <div className="borrow-popup-content-body-main">
                <div className="borrow-popup-content-body-main-first">
                  {step === "1" && (
                    <p className="borrow-popup-content-body-main-first-header-text">
                      {t("linkBank.selectBankCountry")}
                    </p>
                  )}
                  {step === "2" && (
                    <p className="borrow-popup-content-body-main-first-header-text">
                      {t("linkBank.enterPhoneNumber")}
                    </p>
                  )}
                  {step === "3" && (
                    <>
                      {props.isUnlinked && (
                        <p className="borrow-popup-content-body-main-first-header-text-title">
                          {t("linkBank.successfullyUnlinkedBankAccounts")}
                        </p>
                      )}
                      {!props.isUnlinked && (
                        <p className="borrow-popup-content-body-main-first-header-text-title">
                          {t("linkBank.associatedBankAccounts", {
                            bankList: props.bankList?.length,
                          })}
                        </p>
                      )}
                      {props?.bankList?.length > 0 && (
                        <p className="borrow-popup-content-body-main-first-header-text-label">
                          {t("linkBank.linkOrReconnectBank")}
                        </p>
                      )}
                      {props?.bankList?.length === 0 && (
                        <p className="borrow-popup-content-body-main-first-header-text-label">
                          {t("linkBank.linkBankOrCardInstruction")}
                        </p>
                      )}
                    </>
                  )}
                </div>

                {step !== "3" && (
                  <div className="profile-edit-contact-body">
                    <div className="profile-edit-contact-content">
                      <div className="profile-edit-contact-input-container">
                        <div className="profile-edit-contact-input">
                          <div
                            onClick={() => {
                              if (!searchActive) {
                                setStep("1");
                              }
                              setSearchActive(!searchActive);
                            }}
                            className="profile-edit-contact-first-section"
                          >
                            <div className="profile-edit-contact-selection-icon">
                              <img
                                onClick={() => {
                                  setSearchActive(!searchActive);
                                }}
                                style={{
                                  minHeight: "24px",
                                  minWidth: "24px",
                                }}
                                alt="Country Flag"
                                src={selectedCountry.flag}
                              />
                            </div>

                            <p
                              onClick={() => {
                                setSearchActive(!searchActive);
                              }}
                              className="profile-edit-contact-selection-text"
                            >
                              +{selectedCountry.area?.replace("+", "")}
                            </p>
                            {searchActive && (
                              <img
                                onClick={() => {
                                  setSearchActive(!searchActive);
                                }}
                                alt="Dropdown Icon"
                                src={arrowUp}
                              />
                            )}
                            {!searchActive && (
                              <img
                                onClick={() => {
                                  setSearchActive(!searchActive);
                                }}
                                alt="Dropdown Icon"
                                src={dropdownIcon}
                              />
                            )}
                          </div>

                          <input
                            onInputCapture={(e) => {
                              setSearchActive(false);
                              setStep("2");
                              if (e.target.value === "") {
                                setUserInput(userInput + " ");
                              } else {
                                setUserInput(e.target.value);
                              }
                              const withoutDot = e.target.value.replace(
                                ".",
                                "",
                              );
                              const withoutDotAndDash = withoutDot.replace(
                                "-",
                                "",
                              );
                              setUserNumber(withoutDotAndDash);
                            }}
                            onInput={(e) => {
                              handleNextButtonDisplay();
                            }}
                            type="number"
                            className="profile-edit-contact-second-section"
                            placeholder={t("placeholder.phoneNumber")}
                          />
                        </div>
                        {searchActive && (
                          <>
                            {!countryList && <p>{t("common.loading")}...</p>}
                            {countryList && countryList?.length > 0 && (
                              <div className="mobille-startup-search-box-container">
                                <div className="mobile-startup-search-box">
                                  <img
                                    src={searchIcon}
                                    alt="Search Icon"
                                    className="mobile-search-icon"
                                  />
                                  <input
                                    onInput={(e) => {
                                      if (e.target.value === "") {
                                        setNewSearchContent(null);
                                      } else {
                                        setNewSearchContent(
                                          countryList?.filter(
                                            // eslint-disable-next-line array-callback-return
                                            (src) => {
                                              if (
                                                src.name
                                                  .toLowerCase()
                                                  .includes(
                                                    e.target.value.toLowerCase(),
                                                  )
                                              ) {
                                                src.searched =
                                                  e.target.value.toLowerCase();
                                                src.nameArray =
                                                  src.name.split("");
                                                return src;
                                              }
                                            },
                                          ),
                                        );
                                      }

                                      handleNextButtonDisplay();
                                    }}
                                    type="text"
                                    className="ms-search-box-content"
                                    placeholder={t("placeholder.search")}
                                  />
                                </div>
                                <div className="mobile-startup-search-content">
                                  <div
                                    style={
                                      props.contentMaxHeight
                                        ? {
                                            maxHeight: `${props.contentMaxHeight}px`,
                                          }
                                        : {}
                                    }
                                    className="ms-search-content-container"
                                  >
                                    {!newSearchContent &&
                                      countryList?.length > 0 &&
                                      countryList?.map((src, idx) => (
                                        <div
                                          key={idx}
                                          onClickCapture={() => {
                                            setSelectedCountry({
                                              area: src?.phone_code,
                                              flag: src?.flag,
                                              name: src.name,
                                              continent: src.continent,
                                              code: src?.code?.toUpperCase(),
                                            });
                                            if (
                                              src?.code?.toLowerCase() === "ch"
                                            ) {
                                              setIsCheckboxClicked(false);
                                            }
                                          }}
                                          onClick={() => {
                                            setSelectedCountry({
                                              area: src?.phone_code,
                                              flag: src?.flag,
                                              name: src.name,
                                              continent: src.continent,
                                              code: src?.code?.toUpperCase(),
                                            });
                                            if (setSearchActive) {
                                              setSearchActive(!searchActive);
                                            }
                                            setNewSearchContent(null);
                                            setStep("2");
                                            handleNextButtonDisplay();
                                            if (
                                              src?.code?.toLowerCase() === "ch"
                                            ) {
                                              setIsCheckboxClicked(false);
                                            }
                                          }}
                                          className="ms-search-content"
                                        >
                                          <img
                                            src={src?.flag}
                                            alt="Search Result Icon"
                                            className="ms-search-content-icon"
                                          />
                                          <p className="ms-search-content-text">
                                            {src.name}
                                          </p>
                                        </div>
                                      ))}

                                    {newSearchContent &&
                                      newSearchContent.length > 0 &&
                                      newSearchContent.map((src, idx) => (
                                        <div
                                          key={idx}
                                          onClickCapture={() => {
                                            setSelectedCountry({
                                              area: src?.phone_code,
                                              flag: src?.flag,
                                              name: src.name,
                                              continent: src.continent,
                                              code: src?.code?.toUpperCase(),
                                            });
                                            if (
                                              src?.code?.toLowerCase() === "ch"
                                            ) {
                                              setIsCheckboxClicked(false);
                                            }
                                          }}
                                          onClick={() => {
                                            setSelectedCountry({
                                              area: src?.phone_code,
                                              flag: src?.flag,
                                              name: src.name,
                                              continent: src.continent,
                                              code: src?.code?.toUpperCase(),
                                            });
                                            if (setSearchActive) {
                                              setSearchActive(!searchActive);
                                            }
                                            setNewSearchContent(null);
                                            setStep("2");
                                            handleNextButtonDisplay();
                                            if (
                                              src?.code?.toLowerCase() === "ch"
                                            ) {
                                              setIsCheckboxClicked(false);
                                            }
                                          }}
                                          className="ms-search-content"
                                        >
                                          <img
                                            src={src?.flag}
                                            alt="Search Result Icon"
                                            className="ms-search-content-icon"
                                          />
                                          <p className="ms-search-content-text">
                                            {src.nameArray?.length > 0 &&
                                              src.nameArray.map((nm, idx) => (
                                                <>
                                                  {!src.searched.includes(
                                                    nm.toLowerCase(),
                                                  ) && (
                                                    <span
                                                      key={idx}
                                                      style={{
                                                        color: "#B6B7C3",
                                                      }}
                                                    >
                                                      {nm}
                                                    </span>
                                                  )}
                                                  {src.searched.includes(
                                                    nm.toLowerCase(),
                                                  ) && (
                                                    <span key={idx}>{nm}</span>
                                                  )}
                                                </>
                                              ))}
                                          </p>
                                        </div>
                                      ))}
                                  </div>
                                </div>
                              </div>
                            )}
                          </>
                        )}
                        {userNumber.length !== 10 && userInput.length > 10 && (
                          <div className="profile-edit-contact-input-error">
                            <p className="input-error-text">
                              {t("linkBank.invalidPhoneNumber")}
                            </p>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}

                {step === "3" &&
                  props.bankList?.length > 0 &&
                  !props.isBlink &&
                  !props.isBr && (
                    <div className="link-bannk-popup-bank-list">
                      {props.bankList.map((bnk, idx) => (
                        <div
                          key={idx}
                          className="link-bannk-popup-bank-list-content"
                        >
                          <div className="link-bannk-popup-bank-list-content-cotainer">
                            <div className="link-bannk-popup-bank-list-content-icon">
                              {bnk?.iconUrl && (
                                <img src={bnk.iconUrl} alt="Bank Icon" />
                              )}
                              {!bnk?.iconUrl && (
                                <Avatar name={bnk.productName} />
                              )}
                            </div>

                            <div className="link-bannk-popup-bank-list-content-text-cont">
                              <div className="link-bannk-popup-bank-list-content-text">
                                <p className="link-bannk-popup-bank-list-content-title">
                                  {bnk.productName}
                                </p>

                                <p className="link-bannk-popup-bank-list-content-label">
                                  {" "}
                                  {bnk.accountName}
                                </p>
                              </div>

                              <img src={selectBankClicked} alt="" />
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}

                {step === "3" &&
                  props.bankList?.length > 0 &&
                  props.isBlink && (
                    <div className="link-bannk-popup-bank-list">
                      {props.bankList.map((bnk, idx) => (
                        <div
                          key={idx}
                          className="link-bannk-popup-bank-list-content"
                        >
                          <div className="link-bannk-popup-bank-list-content-cotainer">
                            <div className="link-bannk-popup-bank-list-content-icon">
                              {bnk?.iconUrl && (
                                <img src={bnk.iconUrl} alt="Bank Icon" />
                              )}
                              {!bnk?.iconUrl && (
                                <Avatar name={bnk.accountOwner} />
                              )}
                            </div>

                            <div className="link-bannk-popup-bank-list-content-text-cont">
                              <div className="link-bannk-popup-bank-list-content-text">
                                <p className="link-bannk-popup-bank-list-content-title">
                                  {bnk.accountOwner}
                                </p>

                                <p className="link-bannk-popup-bank-list-content-label">
                                  {bnk.account?.type}-
                                  {bnk.account?.identification}
                                </p>
                              </div>

                              <img src={selectBankClicked} alt="" />
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}

                {step === "3" && props.bankList?.length > 0 && props.isBr && (
                  <div className="link-bannk-popup-bank-list">
                    {props.bankList.map((bnk, idx) => (
                      <div
                        key={idx}
                        className="link-bannk-popup-bank-list-content"
                      >
                        <div className="link-bannk-popup-bank-list-content-cotainer">
                          <div className="link-bannk-popup-bank-list-content-icon">
                            {bnk?.iconUrl && (
                              <img src={bnk.iconUrl} alt="Bank Icon" />
                            )}
                            {!bnk?.iconUrl && <Avatar name={bnk.brandName} />}
                          </div>

                          <div className="link-bannk-popup-bank-list-content-text-cont">
                            <div className="link-bannk-popup-bank-list-content-text">
                              <p className="link-bannk-popup-bank-list-content-title">
                                {bnk.brandName}
                              </p>

                              <p className="link-bannk-popup-bank-list-content-label">
                                {bnk.type}-{bnk.number}
                              </p>
                            </div>

                            <img src={selectBankClicked} alt="" />
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {step !== "3" && (
          <button
            id="borrow-popup-next-button"
            onClick={(e) => {
              if (
                e.target.className.includes("startup-button") &&
                e.target.className !== "startup-button"
              ) {
                e.target.className = "startup-button-click";
                handleStep2();
              } else {
                const buttonElement = document.getElementsByClassName(
                  "startup-button-active",
                );
                if (buttonElement.length > 0) {
                  buttonElement[0].className = "startup-button-click";
                  handleStep2();
                }
              }
            }}
            className={
              userInput.length === 10 && userNumber.length === 10
                ? "startup-button-active"
                : "startup-button"
            }
          >
            <p className="add-funds-popup-a-f-button-text">
              {" "}
              {t("common.next")}
            </p>
          </button>
        )}
        {step === "3" &&
          props.bankList?.length > 0 &&
          !props.isBlink &&
          !props.isBr && (
            <div
              style={{ marginBottom: "50px" }}
              className="stripe-popup-buttons"
            >
              <button
                onClick={() => {
                  props.setPopupContent(
                    <LoadingPopup
                      setShowPopup={props.setShowPopup}
                      setPopupContent={props.setPopupContent}
                      setPopupContentPosition={props.setPopupContentPosition}
                      setFavouriteClicked={props.setFavouriteClicked}
                      action="moneyhub-connect"
                      isCustom={true}
                      customTextHeader="Searching..."
                      customTextFooter={`Looking for bank account linked with your wallet.`}
                      isReconnect={true}
                      generalDataProps={props.generalDataProps}
                    />,
                  );
                  props.setPopupContentPosition("flex-end");
                  props.setShowPopup(true);
                }}
                className="verify-kyc-button-back"
              >
                <p className="verify-kyc-button-back-text">
                  {" "}
                  {t("linkBank.reconnect")}
                </p>
              </button>
              <button
                onClick={() => {
                  props.setPopupContent(
                    <SuccessPopup
                      setShowPopup={props.setShowPopup}
                      setPopupContent={props.setPopupContent}
                      setPopupContentPosition={props.setPopupContentPosition}
                      isCustom={true}
                      customTextHeader="Congratulations!"
                      customTextFooter={`You have successfully linked ${props.bankList?.length} bank accounts`}
                      setFavouriteClicked={props.setFavouriteClicked}
                      showButton={true}
                      buttonText="Go to payments"
                      buttonFunc={() => {
                        props.setPopupContent(
                          <AddFunds
                            setShowPopup={props.setShowPopup}
                            setPopupContent={props.setPopupContent}
                            setPopupContentPosition={
                              props.setPopupContentPosition
                            }
                            customLoading={props.customLoading}
                            setCustomLoading={props.setCustomLoading}
                            generalDataProps={props.generalDataProps}
                            addFundsAction="add-funds"
                          />,
                        );
                        props.setPopupContentPosition("flex-end");
                        props.setShowPopup(true);
                      }}
                    />,
                  );
                  props.setPopupContentPosition("flex-end");
                  props.setShowPopup(true);
                }}
                className="verify-kyc-button"
              >
                <p className="verify-kyc-button-text">
                  {t("linkBank.linkAccounts")}
                </p>
              </button>
            </div>
          )}
        {step === "3" && props.bankList?.length > 0 && props.isBlink && (
          <React.Fragment>
            <div
              style={{ marginBottom: "30px", marginTop: "10px" }}
              className="stripe-popup-buttons"
            >
              <button
                onClick={() => {
                  props.setPopupContent(
                    <LoadingPopup
                      setShowPopup={props.setShowPopup}
                      setPopupContent={props.setPopupContent}
                      setPopupContentPosition={props.setPopupContentPosition}
                      setFavouriteClicked={props.setFavouriteClicked}
                      action="blink-connect"
                      reconnect={true}
                      isCustom={true}
                      customTextHeader="Connecting..."
                      customTextFooter={`Creating connection gateway to selected bank`}
                      countryCode={props.countryCode}
                      generalDataProps={props.generalDataProps}
                      selectedBank={props.selectedBank}
                    />,
                  );
                  props.setPopupContentPosition("flex-end");
                  props.setShowPopup(true);
                }}
                className="verify-kyc-button-back"
              >
                <p className="verify-kyc-button-back-text">
                  {t("linkBank.reconnect")}
                </p>
              </button>
              <button
                onClick={() => {
                  props.setPopupContent(
                    <SuccessPopup
                      setShowPopup={props.setShowPopup}
                      setPopupContent={props.setPopupContent}
                      setPopupContentPosition={props.setPopupContentPosition}
                      isCustom={true}
                      customTextHeader="Congratulations!"
                      customTextFooter={`You have successfully linked ${props.bankList?.length} bank accounts`}
                      setFavouriteClicked={props.setFavouriteClicked}
                      showButton={true}
                      buttonText="Go to payments"
                      buttonFunc={() => {
                        props.setPopupContent(
                          <AddFunds
                            setShowPopup={props.setShowPopup}
                            setPopupContent={props.setPopupContent}
                            setPopupContentPosition={
                              props.setPopupContentPosition
                            }
                            customLoading={props.customLoading}
                            setCustomLoading={props.setCustomLoading}
                            generalDataProps={props.generalDataProps}
                            addFundsAction="add-funds"
                          />,
                        );
                        props.setPopupContentPosition("flex-end");
                        props.setShowPopup(true);
                      }}
                    />,
                  );
                  props.setPopupContentPosition("flex-end");
                  props.setShowPopup(true);
                }}
                className="verify-kyc-button"
              >
                <p className="verify-kyc-button-text">
                  {t("linkBank.linkAccounts")}
                </p>
              </button>
            </div>

            {props?.isBlink &&
              props?.bankList[0]?.userId?.length > 0 &&
              props?.bankList[0]?.providerId?.length > 0 && (
                <button
                  style={{ marginBottom: "50px" }}
                  id="borrow-popup-next-button"
                  onClick={async () => {
                    props.setPopupContent(
                      <LoadingPopup
                        setShowPopup={props.setShowPopup}
                        setPopupContent={props.setPopupContent}
                        setPopupContentPosition={props.setPopupContentPosition}
                        setFavouriteClicked={props.setFavouriteClicked}
                        reconnect={true}
                        isCustom={true}
                        customTextHeader="Processing..."
                        customTextFooter={`Sending request to unlink bank accounts`}
                        countryCode={props.countryCode}
                        generalDataProps={props.generalDataProps}
                        selectedBank={props.selectedBank}
                      />,
                    );
                    props.setPopupContentPosition("flex-end");
                    props.setShowPopup(true);
                    await blinkRevokeLastPermission(
                      props?.bankList[0]?.userId,
                      props?.bankList[0]?.providerId,
                    )
                      .then((res) => {
                        if (res) {
                          props.setPopupContent(
                            <LinkBank
                              setShowPopup={props.setShowPopup}
                              setPopupContent={props.setPopupContent}
                              setPopupContentPosition={
                                props.setPopupContentPosition
                              }
                              setFavouriteClicked={props.setFavouriteClicked}
                              currentStep="3"
                              bankList={[]}
                              generalDataProps={props.generalDataProps}
                              isBlink={true}
                              selectedBank={props.selectedBank}
                              countryList={props.countryList}
                              buttonAction="link-bank"
                              isUnlinked={true}
                            />,
                          );
                          props.setPopupContentPosition("flex-end");
                          props.setShowPopup(true);
                        } else {
                          errorToast(
                            "Oops something went wrong",
                            "error while unlinking bank accounts",
                          );
                          props.setPopupContent(
                            <LinkBank
                              setShowPopup={props.setShowPopup}
                              setPopupContent={props.setPopupContent}
                              setPopupContentPosition={
                                props.setPopupContentPosition
                              }
                              setFavouriteClicked={props.setFavouriteClicked}
                              currentStep="3"
                              bankList={props?.bankList}
                              generalDataProps={props.generalDataProps}
                              isBlink={true}
                              selectedBank={props.selectedBank}
                              countryList={props.countryList}
                              buttonAction="link-bank"
                            />,
                          );
                          props.setPopupContentPosition("flex-end");
                          props.setShowPopup(true);
                          console.error(
                            "Error while revoking permission: ",
                            "revoke failed",
                          );
                        }
                      })
                      .catch((err) => {
                        errorToast(
                          "Oops something went wrong",
                          "error while unlinking bank accounts",
                        );
                        props.setPopupContent(
                          <LinkBank
                            setShowPopup={props.setShowPopup}
                            setPopupContent={props.setPopupContent}
                            setPopupContentPosition={
                              props.setPopupContentPosition
                            }
                            setFavouriteClicked={props.setFavouriteClicked}
                            currentStep="3"
                            bankList={props?.bankList}
                            generalDataProps={props.generalDataProps}
                            isBlink={true}
                            selectedBank={props.selectedBank}
                            countryList={props.countryList}
                            buttonAction="link-bank"
                          />,
                        );
                        props.setPopupContentPosition("flex-end");
                        props.setShowPopup(true);
                        console.error("Error while revoking permission: ", err);
                      });
                  }}
                  className="startup-button-click"
                >
                  <p className="add-funds-popup-a-f-button-text">
                    {t("linkBank.unlinkAccounts")}
                  </p>
                </button>
              )}
          </React.Fragment>
        )}
        {step === "3" && props.bankList?.length > 0 && props.isBr && (
          <React.Fragment>
            <div
              style={{ marginBottom: "30px", marginTop: "10px" }}
              className="stripe-popup-buttons"
            >
              <button
                onClick={() => {
                  props.setPopupContent(
                    <LoadingPopup
                      setShowPopup={props.setShowPopup}
                      setPopupContent={props.setPopupContent}
                      setPopupContentPosition={props.setPopupContentPosition}
                      setFavouriteClicked={props.setFavouriteClicked}
                      action="iniciador-connect"
                      reconnect={true}
                      isCustom={true}
                      customTextHeader="Connecting..."
                      customTextFooter={`Creating connection gateway to selected bank`}
                      countryCode={props.countryCode}
                      generalDataProps={props.generalDataProps}
                      selectedBank={props.selectedBank}
                    />,
                  );
                  props.setPopupContentPosition("flex-end");
                  props.setShowPopup(true);
                }}
                className="verify-kyc-button-back"
              >
                <p className="verify-kyc-button-back-text">
                  {" "}
                  {t("linkBank.reconnect")}
                </p>
              </button>
              <button
                onClick={() => {
                  props.setPopupContent(
                    <SuccessPopup
                      setShowPopup={props.setShowPopup}
                      setPopupContent={props.setPopupContent}
                      setPopupContentPosition={props.setPopupContentPosition}
                      isCustom={true}
                      customTextHeader="Congratulations!"
                      customTextFooter={`You have successfully linked ${props.bankList?.length} bank accounts`}
                      setFavouriteClicked={props.setFavouriteClicked}
                      showButton={true}
                      buttonText="Go to payments"
                      buttonFunc={() => {
                        props.setPopupContent(
                          <AddFunds
                            setShowPopup={props.setShowPopup}
                            setPopupContent={props.setPopupContent}
                            setPopupContentPosition={
                              props.setPopupContentPosition
                            }
                            customLoading={props.customLoading}
                            setCustomLoading={props.setCustomLoading}
                            generalDataProps={props.generalDataProps}
                            addFundsAction="add-funds"
                          />,
                        );
                        props.setPopupContentPosition("flex-end");
                        props.setShowPopup(true);
                      }}
                    />,
                  );
                  props.setPopupContentPosition("flex-end");
                  props.setShowPopup(true);
                }}
                className="verify-kyc-button"
              >
                <p className="verify-kyc-button-text">
                  {t("linkBank.linkAccounts")}
                </p>
              </button>
            </div>

            {props?.isBr && props?.bankList[0]?.userId?.length > 0 && (
              <button
                style={{ marginBottom: "50px" }}
                id="borrow-popup-next-button"
                onClick={async () => {
                  props.setPopupContent(
                    <LoadingPopup
                      setShowPopup={props.setShowPopup}
                      setPopupContent={props.setPopupContent}
                      setPopupContentPosition={props.setPopupContentPosition}
                      setFavouriteClicked={props.setFavouriteClicked}
                      reconnect={true}
                      isCustom={true}
                      customTextHeader="Processing..."
                      customTextFooter={`Sending request to unlink bank accounts`}
                      countryCode={props.countryCode}
                      generalDataProps={props.generalDataProps}
                      selectedBank={props.selectedBank}
                    />,
                  );
                  props.setPopupContentPosition("flex-end");
                  props.setShowPopup(true);
                  await iniciadorRevokeLink(props?.bankList[0]?.userId)
                    .then((res) => {
                      if (res) {
                        props.setPopupContent(
                          <LinkBank
                            setShowPopup={props.setShowPopup}
                            setPopupContent={props.setPopupContent}
                            setPopupContentPosition={
                              props.setPopupContentPosition
                            }
                            setFavouriteClicked={props.setFavouriteClicked}
                            currentStep="3"
                            bankList={[]}
                            generalDataProps={props.generalDataProps}
                            isBlink={true}
                            selectedBank={props.selectedBank}
                            countryList={props.countryList}
                            buttonAction="link-bank"
                            isUnlinked={true}
                          />,
                        );
                        props.setPopupContentPosition("flex-end");
                        props.setShowPopup(true);
                      } else {
                        errorToast(
                          "Oops something went wrong",
                          "error while unlinking bank accounts",
                        );
                        props.setPopupContent(
                          <LinkBank
                            setShowPopup={props.setShowPopup}
                            setPopupContent={props.setPopupContent}
                            setPopupContentPosition={
                              props.setPopupContentPosition
                            }
                            setFavouriteClicked={props.setFavouriteClicked}
                            currentStep="3"
                            bankList={props?.bankList}
                            generalDataProps={props.generalDataProps}
                            isBlink={true}
                            selectedBank={props.selectedBank}
                            countryList={props.countryList}
                            buttonAction="link-bank"
                          />,
                        );
                        props.setPopupContentPosition("flex-end");
                        props.setShowPopup(true);
                        console.error(
                          "Error while revoking permission: ",
                          "revoke failed",
                        );
                      }
                    })
                    .catch((err) => {
                      errorToast(
                        "Oops something went wrong",
                        "error while unlinking bank accounts",
                      );
                      props.setPopupContent(
                        <LinkBank
                          setShowPopup={props.setShowPopup}
                          setPopupContent={props.setPopupContent}
                          setPopupContentPosition={
                            props.setPopupContentPosition
                          }
                          setFavouriteClicked={props.setFavouriteClicked}
                          currentStep="3"
                          bankList={props?.bankList}
                          generalDataProps={props.generalDataProps}
                          isBlink={true}
                          selectedBank={props.selectedBank}
                          countryList={props.countryList}
                          buttonAction="link-bank"
                        />,
                      );
                      props.setPopupContentPosition("flex-end");
                      props.setShowPopup(true);
                      console.error("Error while revoking permission: ", err);
                    });
                }}
                className="startup-button-click"
              >
                <p className="add-funds-popup-a-f-button-text">
                  {t("linkBank.unlinkAccounts")}
                </p>
              </button>
            )}
          </React.Fragment>
        )}
        {step === "3" && props.bankList?.length === 0 && props.isBlink && (
          <button
            style={{ marginBottom: "50px" }}
            id="borrow-popup-next-button"
            onClick={async () => {
              props.setPopupContent(
                <LinkBankOption
                  setShowPopup={props.setShowPopup}
                  setPopupContent={props.setPopupContent}
                  setPopupContentPosition={props.setPopupContentPosition}
                  setFavouriteClicked={props.setFavouriteClicked}
                  showMoneyHub={true}
                  generalDataProps={props.generalDataProps}
                />,
              );
              props.setPopupContentPosition("flex-end");
              props.setShowPopup(true);
            }}
            className="startup-button-active"
          >
            <p className="add-funds-popup-a-f-button-text">
              {" "}
              {t("linkBank.linkBankOrCard")}
            </p>
          </button>
        )}
        {step === "3" && props.bankList?.length === 0 && props.isBr && (
          <button
            style={{ marginBottom: "50px" }}
            id="borrow-popup-next-button"
            onClick={async () => {
              props.setPopupContent(
                <LinkBankOption
                  setShowPopup={props.setShowPopup}
                  setPopupContent={props.setPopupContent}
                  setPopupContentPosition={props.setPopupContentPosition}
                  setFavouriteClicked={props.setFavouriteClicked}
                  showMoneyHub={true}
                  generalDataProps={props.generalDataProps}
                />,
              );
              props.setPopupContentPosition("flex-end");
              props.setShowPopup(true);
            }}
            className="startup-button-active"
          >
            <p className="add-funds-popup-a-f-button-text">
              {t("linkBank.linkBankOrCard")}
            </p>
          </button>
        )}
      </div>
    </>
  );
};

export default LinkBank;
